import styled from "styled-components";
import { device } from "../../device.js";

import Button from "@material-ui/core/Button";
import Lottie from "react-lottie-player";

export const Wrapper = styled.div`
    position: relative;
    height: auto;
    width: 100%;
    /* background-color: #db7a00; */
`;

export const StyledLogo = styled.img`
    position: absolute;
    z-index: 1;
    width: 45%;
    height: auto;
    top: 5vh;
    @media ${device.mobileXS} {
        top: 0vh;
        width: 45vw;
    }
    @media ${device.mobileS} {
        top: 0vh;
        width: calc(25vh);
    }
    @media ${device.mobileL} {
        width: calc(40vw - 5vh);
    }
`;

export const LottieCharWrapper = styled.div`
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 75%;
`;

export const StyledLottie = styled(Lottie)`
    width: 100%;
    height: 100%;

    @media ${device.mobileXS} {
        height: 100%;
    }
    @media ${device.mobileS} {
        height: 100%;
    }
    @media ${device.iPhone5} {
        height: 95%;
    }
    @media ${device.mobileM} {
        height: 100%;
    }
    @media ${device.iPhone6} {
        height: 100%;
    }
    @media ${device.iPhoneX} {
        height: 95%;
    }
    @media ${device.mobileL} {
        height: 100%;
    }
`;

export const StyledLottieBg = styled(Lottie)`
    width: 100%;
    height: 100vh;
`;

export const NextButton = styled(Button)`
    font-weight: 700;
    z-index: 2;
    position: absolute;
    bottom: 14vh;
    width: 20%;
    color: #000;
    background-color: white;
    border-radius: 50px;

    &:hover {
        color: #fff;
        background-color: #000;
    }
    @media ${device.mobileXS} {
        bottom: 13vh;
    }
    @media ${device.mobileS} {
        bottom: 12vh;
    }
    @media ${device.iPhone5} {
        bottom: 16vh;
    }
    @media ${device.iPhone6} {
        bottom: 14vh;
    }
    @media ${device.iPhone6Plus} {
        bottom: 14vh;
    }
    @media ${device.iPhoneX} {
        bottom: 16vh;
    }
    @media ${device.iPhone11} {
        bottom: 15vh;
    }
`;
